import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/close_btn.png'
import _imports_1 from '@/assets/icon/check_on.svg'
import _imports_2 from '@/assets/icon/check_off.svg'


const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "file-upload-popup" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-body" }
const _hoisted_5 = { class: "contents_body" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  src: _imports_1
}
const _hoisted_8 = {
  key: 1,
  src: _imports_2
}
const _hoisted_9 = { class: "popup-footer" }

import { ref, onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'StatusPop',
  props: {
    status: {}
  },
  emits: ["closePopup"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

// 상태 목록과 선택 상태 인덱스 정의
const statuses = ["대기", "착수보고", "중간보고", "완료보고"];
const selectedStatus = ref<number | null>(null);

// 컴포넌트가 마운트될 때 props.status 값을 초기화
onMounted(() => {
  selectedStatus.value = statuses.indexOf(props.status || "");
});

// 상태를 선택할 때 호출되는 함수
const selectStatus = (index: number) => {
  selectedStatus.value = index;
};

// 선택한 상태를 부모 컴포넌트로 emit
const confirmSelection = (flag: boolean) => {
  if (selectedStatus.value !== null) {
    const status = statuses[selectedStatus.value];
    emit("closePopup", { popupType: "status", refresh: flag, selectedData: status });
  } else {
    alert("확정하기 전에 상태를 선택해 주세요.");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "popup_cover" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "popup_title" }, "수행상태 변경", -1)),
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmSelection(false))),
          class: "close_icon"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statuses, (status, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass(["contents_div", { selected: selectedStatus.value === index }]),
              onClick: ($event: any) => (selectStatus(index))
            }, [
              (selectedStatus.value === index)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (_openBlock(), _createElementBlock("img", _hoisted_8)),
              _createElementVNode("div", null, _toDisplayString(status), 1)
            ], 10, _hoisted_6)
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: "popup_confirm_btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmSelection(true)))
        }, "확정")
      ])
    ])
  ]))
}
}

})